import { appColors } from '@/src/theme'
import { Box, Flex, Text } from '@chakra-ui/react'
import { FlexCol, FlexRow } from '@components'
import { getDateFnsLocale } from '@shared/application/translation.service'
import { numberFormat } from '@shared/utils'
import { format, parseISO } from 'date-fns'
import { t } from 'i18next'
import i18n from 'i18next'
import type { TooltipProps } from 'recharts'

export const LoadProfileDetailsGraphTooltip = ({
  active,
  payload,
  label,
  isQuarterly,
  isOnlyOneDay,
  hideDate,
}: TooltipProps<number, string> & { isQuarterly: boolean; isOnlyOneDay: boolean; hideDate?: boolean }) => {
  const dateLocale = getDateFnsLocale(i18n.language)

  if (active && payload && payload.length) {
    const { timestamp, value_kw, day, day_total_kwh } = payload[0].payload

    const valueToDisplay = isQuarterly ? value_kw : day_total_kwh
    let tooltipHeader = isQuarterly
      ? format(parseISO(timestamp), isOnlyOneDay ? 'dd LLL yyyy HH:mm' : 'EEEE, dd LLL yyyy HH:mm', { locale: dateLocale })
      : format(parseISO(day), 'EEEE, dd LLL yyyy', { locale: dateLocale })
    if (isQuarterly && hideDate) {
      tooltipHeader = format(parseISO(timestamp), 'HH:mm', { locale: dateLocale })
    }
    return (
      <FlexCol
        borderRadius={8}
        borderColor='gray.100'
        borderWidth='2px'
        className='custom-tooltip'
        backgroundColor='white'
        padding={3}
        opacity={'0.95'}
      >
        <Text fontWeight={600}>{tooltipHeader}</Text>

        <FlexRow gap={2} marginTop={2} pl={1}>
          <Flex alignItems='center'>
            <Box width={3} height='4px' backgroundColor={appColors.accentPrimary} marginRight={2} />
            <Text color='gray.800'>{isQuarterly ? `${t('messstellen.power') as string}:` : `${t('messstellen.work') as string}:`}</Text>
          </Flex>
          <Text color='gray.800' marginLeft='auto' fontWeight={600}>
            {valueToDisplay < 5 ? numberFormat(valueToDisplay, 1) : numberFormat(valueToDisplay)} {isQuarterly ? 'kW' : 'kWh'}
          </Text>
        </FlexRow>
      </FlexCol>
    )
  }

  return null
}
